// Mirrors backend/constants/sf004TowerParts.js — the BLUE (SF-004-I) and RED
// (SF-004-J) towers carry the same 13 parts in the same order; only the
// quantities printed on the paper form differ.
export const BLUE_TOWER_PARTS = [
  { key: "ladderFrame", label: "Ladder Frame x1" },
  { key: "nonLadderFrame", label: "Non-Ladder Frame x1" },
  { key: "halfLadderFrame", label: "Half Ladder Frame x1" },
  { key: "halfNonLadderFrame", label: "Half Non-Ladder Frame x1" },
  { key: "wheels", label: "Wheels x4" },
  { key: "kickboardSet", label: "Kickboard Set" },
  { key: "redPoles", label: "Red Poles x8" },
  { key: "bluePoles", label: "Blue Poles x4" },
  { key: "outriggers", label: "Outriggers x4" },
  { key: "platforms", label: "Platforms x2" },
  { key: "clips", label: "Clips x8" },
  { key: "folder", label: "Folder" },
  { key: "scaffTags", label: "Scaff Tags" },
];

export const RED_TOWER_PARTS = [
  { key: "ladderFrame", label: "Ladder Frame x2" },
  { key: "nonLadderFrame", label: "Non-Ladder Frame x2" },
  { key: "halfLadderFrame", label: "Half Ladder Frame x1" },
  { key: "halfNonLadderFrame", label: "Half Non-Ladder Frame x1" },
  { key: "wheels", label: "Wheels x4" },
  { key: "kickboardSet", label: "Kickboard Set" },
  { key: "redPoles", label: "Red Poles x12" },
  { key: "bluePoles", label: "Blue Poles x6" },
  { key: "outriggers", label: "Outriggers x4" },
  { key: "platforms", label: "Platforms x2" },
  { key: "clips", label: "Clips x12" },
  { key: "folder", label: "Folder" },
  { key: "scaffTags", label: "Scaff Tags" },
];

export const TOWER_CHECKLIST_INTRO =
  "This checklist is to be completed when taking the tower from Stores to ensure all parts are available, taken and fit for use.";
